import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Crest } from '../../UniversityCrest';
import { Eyebrow } from './parts';
import { COLLEGE_LINKS_COPY as COPY, FEATURED_COLLEGES, PHONE_SHOWN } from '../../../content/collegeLinks';
import { EVENTS, track } from '../../../services/analytics';

// "Look up a college" (#4434 plan A, founder pick A1, 2026-10-16): 20 college
// pages linked from the homepage (after How it works) and from /resources
// (under the header). Real links in the prerendered HTML, each named by the
// school's full name. On a phone the first PHONE_SHOWN show and the rest fold
// behind a button; the folded ones stay in the HTML (`hidden sm:block`), so
// Google reads all 20 either way.
function Card({ c, index, from, folded }) {
    return (
        <li className={`min-w-0 ${folded ? 'hidden sm:block' : ''}`} data-testid={`college-link-${c.slug}`}>
            <Link
                to={`/colleges/${c.slug}`}
                onClick={() => track(EVENTS.COLLEGE_LINK_CLICKED, { from, to: c.slug, position: index + 1 })}
                className="flex h-full min-h-[56px] items-start gap-2.5 rounded-xl border border-[#E0DED8] bg-white px-3 py-2.5 transition-shadow hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1A4D2E]"
            >
                <Crest name={c.name} branding={c.branding} size={32} />
                <span className="min-w-0">
                    <span className="block text-sm font-semibold leading-snug text-[#1A2E1F] [overflow-wrap:anywhere]">{c.name}</span>
                    <span className="block text-xs leading-snug text-[#4A4A4A]">{COPY.rate(c)}</span>
                </span>
            </Link>
        </li>
    );
}

function Grid({ from }) {
    const [open, setOpen] = useState(false);
    const rest = FEATURED_COLLEGES.length - PHONE_SHOWN;
    return (
        <>
            <ul className="m-0 grid list-none grid-cols-2 gap-2.5 p-0 lg:grid-cols-4" data-testid={`college-links-${from}`}>
                {FEATURED_COLLEGES.map((c, i) => (
                    <Card key={c.slug} c={c} index={i} from={from} folded={!open && i >= PHONE_SHOWN} />
                ))}
            </ul>
            {!open && rest > 0 && (
                <p className="mt-3 text-center sm:hidden">
                    <button
                        type="button"
                        onClick={() => { setOpen(true); track(EVENTS.COLLEGE_LINKS_EXPANDED, { from }); }}
                        className="min-h-[44px] px-4 text-[15px] font-semibold text-[#1A4D2E] underline underline-offset-2"
                    >
                        {COPY.more(rest)}
                    </button>
                </p>
            )}
        </>
    );
}

const allLink = (from, className) => (
    <Link
        to="/colleges"
        onClick={() => track(EVENTS.COLLEGE_LINK_CLICKED, { from, to: 'all', position: 0 })}
        className={className}
    >
        {COPY.all} <span aria-hidden="true">&rarr;</span>
    </Link>
);

export function HomeCollegeLinks() {
    const copy = COPY.home;
    return (
        <section id="colleges" data-landing-section="colleges" data-testid="landing-colleges" aria-labelledby="landing-colleges-title"
            className="scroll-mt-20 border-y border-[#E0DED8] bg-white px-4 py-10 sm:px-6 lg:px-8 lg:py-16">
            <div className="mx-auto max-w-5xl">
                <div className="text-center">
                    <Eyebrow>{copy.eyebrow}</Eyebrow>
                    <h2 id="landing-colleges-title" className="[text-wrap:balance] font-serif text-3xl font-bold text-[#1A4D2E] sm:text-4xl">{copy.title}</h2>
                    <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-[#4A4A4A] [text-wrap:balance]">{copy.sub}</p>
                </div>
                <div className="mt-6"><Grid from="home" /></div>
                <p className="mt-5 text-center">
                    {allLink('home', 'inline-flex min-h-[44px] items-center gap-1 rounded-full border border-[#1A4D2E] px-5 text-[15px] font-semibold text-[#1A4D2E] hover:bg-[#F0F7F1]')}
                </p>
            </div>
        </section>
    );
}

export function ResourcesCollegeLinks() {
    const copy = COPY.resources;
    return (
        <section data-testid="resources-colleges" aria-labelledby="resources-colleges-title" className="border-b border-[#E0DED8] bg-white">
            <div className="mx-auto max-w-6xl px-4 py-7 sm:px-6 lg:px-8">
                <div className="mb-3 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
                    <h2 id="resources-colleges-title" className="font-serif text-[22px] font-bold leading-tight text-[#1A2E1F]">{copy.title}</h2>
                    {allLink('resources', 'inline-flex min-h-[44px] items-center gap-1 text-sm font-semibold text-[#1A4D2E] underline underline-offset-2')}
                </div>
                <p className="mb-3.5 text-[15px] leading-relaxed text-[#4A4A4A]">{copy.sub}</p>
                <Grid from="resources" />
            </div>
        </section>
    );
}
